import { z } from "zod";
/**
 * The two controls every screen on a report carries: a date range and an engine.
 *
 * One definition rather than one per screen. This shape had been copied into
 * `citations.ts`, `prompt-table.ts` and `capture-progress.ts` byte for byte,
 * leaving multiple copies of a filter. Each copy is another place for the day range and the engine name to drift apart, and the
 * symptom of that drift is two screens on the same report disagreeing about a
 * number with no visible reason why.
 *
 * `from` and `to` are inclusive `YYYY-MM-DD` strings in UTC, matching the
 * `@db.Date` column they are compared against. Strings rather than dates all
 * the way through: the URL, the API and the display all want the string, and
 * every conversion between a local `Date` and a UTC day is a chance to shift a
 * range by one for anyone west of Greenwich.
 */
export const isoDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/u, "expected an ISO date, e.g. 2026-08-01");
export const reportFilterSchema = z.object({
    from: isoDateSchema,
    to: isoDateSchema,
    /** Absent means every engine. There is no wildcard value to spell. */
    engine: z.string().trim().min(1).max(40).optional(),
});
//# sourceMappingURL=report-filter.js.map